import { render, staticRenderFns } from "./wxWebPay.vue?vue&type=template&id=963fee20&scoped=true"
import script from "./wxWebPay.vue?vue&type=script&lang=js"
export * from "./wxWebPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963fee20",
  null
  
)

export default component.exports